import { ReactElement } from 'react'
import styled from 'styled-components'

interface PartMessageProps {
  message: string
  fullWidth?: boolean
}

const PartMessage = ({
  message,
  fullWidth,
}: PartMessageProps): ReactElement | null => {
  if (!message) return null
  return (
    <PartMessageBox $fullWidth={fullWidth}>
      <span className="material-icons md-18">campaign</span>
      <PartMessageText>{message}</PartMessageText>
    </PartMessageBox>
  )
}

export default PartMessage

const PartMessageBox = styled.div<{ $fullWidth?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  border: 1px solid #000;
  padding: 8px;
  margin-top: 12px;
  width: fit-content;
  max-width: ${(p) => (p.$fullWidth ? '100%' : '230px')};

  .material-icons {
    flex-shrink: 0;
  }
`

const PartMessageText = styled.span`
  font-family: Roboto, serif;
  font-size: 14px;
  line-height: 20px;
  word-break: break-word;
`
